import React, { useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Grid,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@mui/material";
import PageTitle from "../../components/Layout/PageTitle";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { GetAPI } from "../../Components/Backend/GetAPI";
import { PostAPI } from "../../Components/Backend/PostAPI";
import { formatDateTime, usePermiteAcesso } from "../../Components/Funcionais/Utils";
import APIAxios from "../../Api/APIAxios";
import InputAdornment from "@mui/material/InputAdornment";
import PersonIcon from "@mui/icons-material/Person";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

const PerfisIncluir = () => {
  //***************************************   AVISOS E LOADING ************************************************* */
  // CONTROLE DE AVISOS E ALERTAS
  //Funcão para fechar avisos e alertas
  usePermiteAcesso(2) //Administrador de Acessos
  const [avisoErro, setAvisoErro] = useState("");
  const [avisoSucesso, setAvisoSucesso] = useState("");
  const [loading, setLoading] = useState(false);
  //************************************************************************************************** */

  //***************************************   SALVAR e SALVAR + NOVO ********************************* */
  const [modoIncluirMais, setModoIncluirMais] = useState(false);
  //************************************************************************************************** */

  const navigate = useNavigate();
  const apiAxios = APIAxios();

  const [modulosSelecionados, setModulosSelecionados] = useState([]);
  const [gruposSelecionados, setGruposSelecionados] = useState([]);
  const [modulos, setModulos] = useState([]);
  const [grupos, setGrupos] = useState([]);

  const [formData, setFormData] = useState({
    id: 0,
    nome: "",
    modulos: [],
    grupos: [],
  });

  const buscaModulos = async () => {
    setLoading(true);

    const response = await GetAPI(apiAxios, "/modulos");

    setLoading(false);

    if (response.success) {
      setModulos(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar módulos.");
    }
  };

  const buscaGrupos = async () => {
    setLoading(true);

    const response = await GetAPI(apiAxios, "/grupos");

    setLoading(false);

    if (response.success) {
      setGrupos(response.data);
    } else {
      setAvisoErro(response.errorMessage || "Erro ao carregar Grupos.");
    }
  };

  useEffect(() => {
    buscaModulos();
    buscaGrupos();
  }, []);

  const handleVoltar = () => {
    navigate("/perfis/lista");
  };

  // Se o valor do campo for uma string, converte para maiúsculas
  const handleChange = (event, tam) => {
    const { name, value } = event.target;

    let valor = value;

    //Limita tamanho do campo
    if (typeof value === "string") {
      valor = valor.slice(0, tam);
    }

    setFormData((prevData) => ({
      ...prevData,
      [name]: typeof valor === "string" ? valor.toUpperCase() : valor,
    }));
  };

  // Limpa os campos do formulário após a inclusão, se for incluir mais um registro
  const limparCampos = () => {
    setFormData({
      id: 0,
      nome: "",
      modulos: [],
      grupos:[],
    });
    setModulosSelecionados([]);
    setGruposSelecionados([]);
  };

  // Recebe o clique no botao SALVAR ou no SALVAR + INCLUIR
  // Se for SALVAR + INCLUIR, chama a função limparCampos para limpar os campos do formulário
  const handleSubmit = async (event) => {
    event.preventDefault();

    const registro = {
      ...formData,
      modulos: modulosSelecionados.map(id =>  id ), // << aqui
      grupos: gruposSelecionados.map(id =>  id ), // << aqui
    };

    setLoading(true);

    const response = await PostAPI(apiAxios, "/perfil", registro);

    setLoading(false);

    if (response.success) {
      setFormData(response.data);

      //Exibe mensagem de sucesso por 5 segundos e limpa a tela
      setAvisoSucesso("Perfil incluído com sucesso!");
      if (modoIncluirMais) {
        limparCampos();
      } else {
        await new Promise((resolve) => setTimeout(resolve, 3000)); // aguarda 3 segundos
        navigate("/perfis/lista");
      }
    } else {
      setAvisoErro(response.errorMessage || "Erro ao atualizar perfil.");
    }
  };

  return (
    <div>
      {/* ******************************* TITULO E FUNCIONALIDADES ************************* */}
      <PageTitle
        caption="Cadastro de Perfis"
        setAvisoErro={setAvisoErro}
        avisoErro={avisoErro}
        avisoSucesso={avisoSucesso}
        setAvisoSucesso={setAvisoSucesso}
        loading={loading}
        accentStyle
      />
      {/* ********************************************************************************** */}

      <Box sx={{ flexGrow: 1 }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            {/* Nome do perfil */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Perfil:"
                variant="outlined"
                value={formData.nome}
                onChange={(e) => handleChange(e, 50)}
                required
                name="nome"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <PersonIcon />
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            {/* MODULOS Acessos */}
            <Grid item xs={12}>
              <FormControl fullWidth margin="normal">
                <InputLabel id="label-modulos">Módulos Acessíveis</InputLabel>
                <Select
                  labelId="label-modulos"
                  multiple
                  value={modulosSelecionados}
                  onChange={(e) => {
                    const v = e.target.value;
                    setModulosSelecionados(
                      (Array.isArray(v) ? v : [v]).map(Number)
                    );
                  }}
                  input={<OutlinedInput label="Módulos Acessíveis" />}
                  renderValue={(selected) =>
                    selected
                      .map((id) => modulos.find((f) => f.id === id)?.nome)
                      .filter(Boolean)
                      .join(", ")
                  }
                >
                  {modulos.map((mod) => (
                    <MenuItem key={mod.id} value={mod.id}>
                      <Checkbox
                        checked={modulosSelecionados.includes(mod.id)}
                      />
                      <ListItemText primary={mod.descricao} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* GRUPOS de Acessos */}
            <Grid item xs={12}>
              <FormControl fullWidth margin="normal">
                <InputLabel id="label-grupos">Grupos Acessíveis</InputLabel>
                <Select
                  labelId="label-grupos"
                  multiple
                  value={gruposSelecionados}
                  onChange={(e) => {
                    const v = e.target.value;
                    setGruposSelecionados(
                      (Array.isArray(v) ? v : [v]).map(Number)
                    );
                  }}
                  input={<OutlinedInput label="Grupos Acessíveis" />}
                  renderValue={(selected) =>
                    selected
                      .map((id) => grupos.find((f) => f.id === id)?.nome)
                      .filter(Boolean)
                      .join(", ")
                  }
                >
                  {grupos.map((mod) => (
                    <MenuItem key={mod.id} value={mod.id}>
                      <Checkbox
                        checked={gruposSelecionados.includes(mod.id)}
                      />
                      <ListItemText primary={mod.nome} />
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>

            {/* Botões */}
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "space-between", // separa esquerda e direita
                alignItems: "center",
                flexWrap: "wrap",
                gap: 2,
                mt: 2,
              }}
            >
              {/* Lado esquerdo - Voltar */}
              <Box sx={{ width: { xs: "100%", md: "auto" } }}>
                <Button
                  variant="contained"
                  size="large"
                  sx={{ backgroundColor: "#1a3865", width: "100%" }}
                  onClick={handleVoltar}
                >
                  Voltar
                </Button>
              </Box>
              {/* Lado direito - Salvar + Incluir / Salvar */}
              <Box sx={{ display: "flex", gap: 2, width: { xs: "100%", md: "auto" }, flexDirection: { xs: "column", md: "row" } }}>
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => setModoIncluirMais(true)}
                  type="submit"
                  sx={{
                    borderColor: "#1a3865",
                    color: "#1a3865",
                  }}
                >
                  Salvar + Incluir
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  sx={{
                    backgroundColor: "#1a3865",
                  }}
                  onClick={() => setModoIncluirMais(false)}
                  type="submit"
                >
                  Salvar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </form>
      </Box>
    </div>
  );
};

export default PerfisIncluir;
